import components from './components.json';

export default { components };
